import type { IConversation } from "@apis/conversations/types"
import { ConversationItem } from "./ConversationItem"

type TConversationListProps = {
  conversation_items: IConversation[]
  inspire_conversation_id: string
  gladly_conversation_id: string
}

export const ConversationList = ({
  conversation_items,
  inspire_conversation_id,
  gladly_conversation_id,
}: TConversationListProps) => {
  if (!conversation_items.length) {
    return (
      <div className="tw:p-4 tw:text-center tw:text-gray-500">
        No conversations to display
      </div>
    )
  }
  return (
    <>
      <div className="tw:text-center tw:text-2xl tw:font-bold">
        <p>
          Inspire Conversation Id:{" "}
          <span className="tw:font-normal">{inspire_conversation_id}</span>
        </p>
        <p>
          Gladly Conversation Id:{" "}
          <span className="tw:font-normal">{gladly_conversation_id}</span>
        </p>
      </div>

      <div className="tw:divide-y tw:divide-gray-200">
        {conversation_items.map((item) => (
          <ConversationItem
            key={item.conversation_item_id}
            conversation={item}
          />
        ))}
      </div>
    </>
  )
}
